<template>
    <div class="footer" v-if="footer">
        <div class="container-fluid">
            <div class="container">
                <div class="row footer__logos" v-html="footer.fields.logos.value"></div>
                <div class="row footer__location">
                    <div class="col" v-html="footer.content"></div>
                </div>
            </div>
            <div class="row footer__developed-by">
                <div class="col">
                    <a href="https://une.ch/" target="_blank">
                        <img src="/images/poweredByUneBlack.svg" alt="Powered By Une">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _find from 'lodash/find';

    export default {
        mounted: function () {
            this.fetchData();
        },
        data () {
            return {
                footer: null
            }
        },
        methods: {
            fetchData () {
                const sections = this.$store.getters.getSections
                const footer = _find(sections, {type: 'footer'})
                this.footer = footer
            }
        }

    }
</script>